// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__RyTMw","footer":"ModalCreateQualiphyProcedure_footer__7IL5G","additionData":"ModalCreateQualiphyProcedure_additionData__33u3F"};